<template>
  <div>
    <div class="searchResultShop" v-for="shop in shops" :key="shop.id">
      <div class="searchResultShop__header">
        <h2 class="title">
          <span v-if="isPromotion" class="searchResultShop__header__PRLabel">PR</span>
          <img v-else-if="shop.rank === 'A'" class="searchResultShop__recommend" src="https://gp2-prod.s3-ap-northeast-1.amazonaws.com/images/shopRecommend.png">
          <a :href="shop.detail_url">{{ shop.name }}</a>
        </h2>
        <shop-search-result-header-checkbox v-if="shop.rank !== 'D'" :shop-id="shop.id"></shop-search-result-header-checkbox>
      </div>
      <div class="searchResultShop__content">
        <div class="searchResultShop__subway">
          <span class="searchResultShop__subwayIcon"><i class="ph ph-map-pin"></i></span>
          <a :href="shop.detail_url" class="searchResultShop__subwayDescription">{{ shop.access }}</a>
        </div>
        <div class="searchResultShop__mainContent">
          <div class="searchResultShop__mainContent__wrapper">
            <div :href="shop.detail_url" class="searchResultShop__mainContentImage">
              <ul class="searchResultShop__mainContentImage__slide" :ref="`slider-${shop.id}`">
                <li v-for="photo in shop.photo_library" :key="photo.id">
                  <div class="searchResultShop__mainContentImage__slide__image" :style="backgroundImage(photo.image.urls.medium)"></div>
                </li>
                <div v-if="shop.photo_library.length === 0" class="searchResultShop__mainContentImage__slide__image" :style="backgroundImage(shop.main_image.urls.medium)"></div>
                <div v-if="shop.photo_library.length === 0 && shop.sub_image" class="searchResultShop__mainContentImage__slide__image" :style="backgroundImage(shop.sub_image.urls.medium)"></div>
                <div v-if="shop.photo_library.length === 0 && shop.sub_image2" class="searchResultShop__mainContentImage__slide__image" :style="backgroundImage(shop.sub_image2.urls.medium)"></div>
              </ul>
            </div>
            <shop-rating :rating="shop.average_rating" :review-count="shop.review_count"></shop-rating>
          </div>
          <a :href="shop.detail_url" class="searchResultShop__mainContentDetail">
            <div class="searchResultShop__mainContentDetailList">
              <span class="searchResultShop__mainContentDetailListLabel">収容人数</span>
              <div class="searchResultShop__mainContentDetailListItem">
                <div class="item">
                  <i class="ph ph-champagne"></i>
                  <p>立食 ～<span style="font-weight: bold">{{shop.max_standing_count}}名</span></p>
                </div>
                <div class="item">
                  <i class="ph ph-fork-knife"></i>
                  <p>着席 ～<span style="font-weight: bold">{{shop.max_count}}名</span></p>
                </div>
              </div>
            </div>
            <div class="searchResultShop__mainContentDetailList">
              <span class="searchResultShop__mainContentDetailListLabel">コース金額</span>
              <div class="searchResultShop__mainContentDetailListItem">
                <div class="item">
                  <i class="ph ph-money"></i>
                  <p class="brand-color">{{ lowestPriceLabel(shop.courses) }}</p>
                </div>
              </div>
            </div>
            <div class="searchResultShop__mainContentDetailList">
              <span class="searchResultShop__mainContentDetailListLabel">ジャンル</span>
              <div class="searchResultShop__mainContentDetailListItem">
                <div class="item">
                  {{ shop.genre_labels.map(genre => genre.label).join('  ') }}
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
      <template v-if="shop.rank !== 'D'">
        <div v-if="shop.courses.length > 0" class="searchResultShop__plan">
          <div v-for="course in shop.courses.slice(0, 2)" :key="course.id" class="searchResultShop__planItem">
            <div class="searchResultShop__planTitle">おすすめプラン</div>
            <div class="searchResultShop__planText">
              <a :href="`${shop.detail_url}plans/${course.id}/#shopPlanContent`">{{ course.name }}</a>
            </div>
          </div>
        </div>
        <div class="searchResultShop__planList">
          <i class="fas fa-chevron-right"></i>
          <a :href="`${shop.detail_url}plans/`">プラン一覧</a>
          <i class="fas fa-chevron-left"></i>
        </div>
      </template>
      <div class="searchResultShop__actionButtonList">
        <div class="searchResultShop__actionButtonListItem">
          <div class="searchResultShop__multipleLike">
            <shop-search-result-checkbox :shop-id="shop.id" :shop-rank="shop.rank"></shop-search-result-checkbox>
          </div>
        </div>
        <div class="searchResultShop__actionButtonListItem">
          <a v-if="shop.rank !== 'D' && shop.twilio_tel" class="ui green button tel_button" :href="'tel:' + shop.twilio_tel">
            <p class="pcOnly" style="margin-bottom: 2px;">電話をかける</p>
            <i class="fas fa-phone fa fa-rotate-90" style="margin-right: 0.4em;"></i>
            {{ formatTelNumber(shop.twilio_tel) }}
          </a>
          <a v-else :href="`${shop.detail_url}reserve`" class="ui green button reserve_button">
            <i class="far fa-envelope" style="margin-right: 6px;"></i>この会場に問い合わせる
          </a>
        </div>
        <div class="searchResultShop__actionButtonListItem">
          <a class="ui button basic orange detail_button" :href="shop.detail_url">詳しく見る</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ShopSearchResultHeaderCheckbox from './shopSearchResultHeaderCheckbox.vue';
import ShopSearchResultCheckbox from './shopSearchResultCheckbox.vue';
import ViewsRatingStars from "./viewsRatingStars.vue";
import ShopRating from "./shopRating.vue";

export default {
    components: {
        ViewsRatingStars,
        'shop-search-result-header-checkbox': ShopSearchResultHeaderCheckbox,
        'shop-search-result-checkbox': ShopSearchResultCheckbox,
        'shop-rating': ShopRating,
    },
    props: {
        shops: {
            required: true,
        },
        isPromotion: {
            required: false,
            type: Boolean,
            default: false,
        }
    },
    mounted() {
        this.initializeSlick();
    },
    watch: {
        shops: {
            immediate: true,
            deep: true,
            handler() {
                this.initializeSlick();
            }
        }
    },
    methods: {
        lowestPriceLabel: function(courses) {
            if (courses.length === 0) {
                return 'お問い合わせください';
            }
            var lowestPriceCourse = _.sortBy(courses, function(course) {
                return course.discounted_price || course.price;
            })[0];
            var label = '';
            if (lowestPriceCourse.drink_type_label) {
                label = lowestPriceCourse.drink_type_label;
            } else {
                label = '飲み放題なし';
            }
            label += ' ' + (lowestPriceCourse.discounted_price || lowestPriceCourse.price) + '円〜/名～';
            return label;
        },
        formatTelNumber: function(tel_number) {
            if (!tel_number) {
                return '';
            } else if (tel_number.length !== 11 || !tel_number.match(/^\d+$/)) {
                return tel_number;
            }
            return `${tel_number.slice(0, 3)}-${tel_number.slice(3, 7)}-${tel_number.slice(7)}`;
        },
        backgroundImage: function(url) {
            return 'background-image: url(' + url + ')';
        },
        initializeSlick: function() {
            this.$nextTick(() => {
                this.shops.forEach((shop) => {
                    let refName = `slider-${shop.id}`;
                    if (!$(this.$refs[refName]).hasClass('slick-initialized')) {
                        let imageCount = shop.photo_library.length;
                        if (shop.main_image) {
                            imageCount++;
                        }
                        if (shop.sub_image) {
                            imageCount++;
                        }
                        if (shop.sub_image2) {
                            imageCount++;
                        }
                        if (this.$refs[refName] && imageCount > 1) {
                            $(this.$refs[refName]).slick({
                                allow: true,
                                infinite: true,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                autoplay: false,
                                lazyLoad: 'ondemand',
                            });
                        } else {
                            $(this.$refs[refName]).addClass('single')
                        }
                    }
                });
            });
        },
    }
};
</script>
